import { TableDemoPagination, TableHeaders } from './table-demo.model';

export const TableHeader: TableHeaders[] = [
  {
    field: 'reference',
    header: 'Reference',
    sortable: true
  },
  {
    field: 'name',
    header: 'Name',
    sortable: false
  },
  {
    field: 'actions',
    header: '',
    sortable: false,
    class: 'action-column'
  }
];

export const TableDemoData: TableDemoPagination = {
  content: [
    {
      reference: '1',
      name: 'Example 1',
      actions: 'Edit'
    },
    {
      reference: '2',
      name: 'Example 2',
      actions: 'Edit'
    },
    {
      reference: '3',
      name: 'Example 3',
      actions: 'Edit'
    }
  ],
  pagination: {
    page: 1,
    size: 10,
    totalElements: 3,
    totalPages: 1
  }
};
